import validate from "/usr/src/app/content/n3-treatments-9bd69d94-cb53-4d31-856c-491a320abca6/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-treatments-9bd69d94-cb53-4d31-856c-491a320abca6/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}